import React, { useEffect, useState } from 'react';
import { Field, Form, Formik, useFormikContext } from 'formik';
import * as Yup from 'yup';
import { Button, Label, TextArea } from 'edozvola-frontend-lib/dist/ui';
import { Col, FormGroup, Row } from 'reactstrap';
import { CaseFinalActOtherInfoModel } from 'app/edozvola/cases/cases.model';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchCaseFinalActOtherInfo, saveCaseFinalActOtherInfo } from 'app/edozvola/cases/service/cases.service';
import { ERRORS, messages } from 'app/config/constants';
import { showToast } from 'app/shared/util/toast.util';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { initCaseFormChange, setFormChanged } from 'app/shared/reducers/case-form-change';
import {updateCaseFinalActOtherInfoMutation} from "app/edozvola/cases/service/cases.queries";

const CaseFinalActOtherInfoForm = () => {
  const { id } = useParams<{ id: string }>();
  const [initialData, setInitialData] = useState<CaseFinalActOtherInfoModel>({} as CaseFinalActOtherInfoModel);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [readonly, setReadonly] = useState(true);
  const {mutate: saveMutation, isPending: isSaving} = updateCaseFinalActOtherInfoMutation(id, data => {
    setInitialData(data);
    showToast(toast.success, messages.DATA_SAVED);
  }, error => {
    if (Object.values(ERRORS).includes(error.response?.data?.detail)) {
      showToast(toast.error, error.response?.data?.detail);
    } else {
      showToast(toast.error, ERRORS.GENERIC_ERROR);
    }
  });

  useEffect(() => {
    fetchCodebooks().then(() => {
      fetchCaseFinalActOtherInfo(id)
        .then(data => {
          setReadonly(data.readonly);
          setInitialData(data);
        })
        .catch(error => {
          if (Object.values(ERRORS).includes(error.response?.data?.detail)) {
            showToast(toast.error, error.response?.data?.detail);
          } else {
            showToast(toast.error, ERRORS.GENERIC_ERROR);
          }
          navigate('/cases/');
        });
    });
  }, [id]);

  const fetchCodebooks = async () => {};

  const FormikValueObserver = ({ onChange }) => {
    const { dirty } = useFormikContext();

    useEffect(() => onChange({ dirty }), [dirty, onChange]);

    return null;
  };

  const validation = Yup.object({});

  const handleSubmit = (values, { setSubmitting }) => {
    saveMutation(values);
  };

  return (
    <>
      <Formik enableReinitialize={true} initialValues={initialData} validationSchema={validation} onSubmit={handleSubmit}>
        {({ errors, isValid, dirty, submitForm, setFieldValue }) => (
          <Form>
            <FormikValueObserver
              onChange={dirty => {
                if (dirty.dirty) {
                  dispatch(setFormChanged(true));
                } else {
                  dispatch(initCaseFormChange());
                }
              }}
            />
            <Row>
              <Col xs={6}>
                <FormGroup>
                  <Label labelText={'Dodatni tekst'} />
                  <Field
                    id="additionalText"
                    name="additionalText"
                    render={({ field }) => <TextArea {...field} type="input" error={!readonly && errors.additionalText} disabled={readonly} />}
                  />
                </FormGroup>
              </Col>
              <Col xs={6}>
                <FormGroup>
                  <Label labelText={'Dodatni tekst u izreci lokacijske dozvole'} />
                  <Field
                    id="locationPermitAdditionalText"
                    name="locationPermitAdditionalText"
                    render={({ field }) => (
                      <TextArea {...field} type="input" error={!readonly && errors.locationPermitAdditionalText} disabled={readonly} />
                    )}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={6}>
                <FormGroup>
                  <Label labelText={'Dodatni tekst u izreci građevinske dozvole'} />
                  <Field
                    id="buildingPermitAdditionalText"
                    name="buildingPermitAdditionalText"
                    render={({ field }) => (
                      <TextArea {...field} type="input" error={!readonly && errors.buildingPermitAdditionalText} disabled={readonly} />
                    )}
                  />
                </FormGroup>
              </Col>
              <Col xs={6}>
                <FormGroup>
                  <Label labelText={'Dodatni tekst u izreci uporabne dozvole'} />
                  <Field
                    id="usePermitAdditionalText"
                    name="usePermitAdditionalText"
                    render={({ field }) => <TextArea {...field} type="input" error={!readonly && errors.usePermitAdditionalText} disabled={readonly} />}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={6}>
                <FormGroup>
                  <Label labelText={'Dodatni tekst u izreci izmjene dozvole'} />
                  <Field
                    id="alterPermitAdditionalText"
                    name="alterPermitAdditionalText"
                    render={({ field }) => (
                      <TextArea {...field} type="input" error={!readonly && errors.alterPermitAdditionalText} disabled={readonly} />
                    )}
                  />
                </FormGroup>
              </Col>
            </Row>

            {!readonly && (
              <div className="case-save-button">
                <Button color={'info'} isLoading={isSaving} label={'Spremi'} size={'lg'} onClick={submitForm} disabled={!dirty || !isValid} />
              </div>
            )}
          </Form>
        )}
      </Formik>
    </>
  );
};

export default CaseFinalActOtherInfoForm;
